import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DefaultRequest } from 'scripts/api';
import { getResourceTo } from 'react/utils/utils';

import UploadIcon from 'static/images/photoAlbum/upload.svg';
import { convertImageToBinary, getLiveAlbumId } from '../utils';

function UploadButton(props) {
  const {
    data: {
      routeId, entity, stopId, key
    },
    fetchAlbums,
    albums,
    type
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const uploadPhoto = (base64Image, extensionImage) => {
    const liveAlbumExists = !!getLiveAlbumId(albums);
    const isStop = entity === 'stop';
    const albumKey = `LIVE_${isStop ? stopId : routeId}`;
    const now = new Date().getTime();

    const fileName = isStop
      ? `${albumKey}_${routeId}_${stopId}_${now}.${extensionImage}`
      : `${albumKey}_${routeId}_${now}.${extensionImage}`;

    const jsonData = {
      pictureInformation: {
        photoAlbum: {
          key: albumKey,
          user: {
            id: Monet.Session.User.id
          },
          route: {
            id: routeId
          }
        }
      }
    };

    const formData = new FormData();

    if (!liveAlbumExists) {
      jsonData.pictureInformation.photoAlbum.description = 'LIVE';
      jsonData.pictureInformation.photoAlbum.time = new Date().toJSON();
    }

    if (isStop) {
      jsonData.pictureInformation.photoAlbum.stop = {
        id: stopId,
        key
      };
    }

    Object.keys(jsonData).forEach((prop) => {
      formData.append(
        prop,
        new Blob([JSON.stringify(jsonData[prop])], { type: 'application/json' })
      );
    });

    formData.append(
      'file',
      new Blob([convertImageToBinary(base64Image)]),
      fileName
    );

    const url = isStop ? 'Photo/Stop/WithAlbum' : 'Photo/Route/WithAlbum';

    setIsLoading(true);
    new DefaultRequest({
      method: 'POST',
      contentType: 'multipart/form-data',
      url,
      success: () => {
        fetchAlbums();
        setIsLoading(false);
      },
      error: () => {
        setIsLoading(true);
      },
      data: formData
    }).send();
  };

  const processFile = (file, data) => {
    const THREE_MEGA_BYTE = 3 * 1024 * 1024;

    const fileName = file.name;
    const extensionImage = String(fileName).split('.').pop();

    if (file.size > THREE_MEGA_BYTE) {
      new Greenmile.Components.AlertModal(
        getResourceTo('galleryPopup.fileSizeError')
      ).show();
      return;
    }

    if (!file.name.match(/\.jpe?g$|\.png$/i)) {
      new Greenmile.Components.AlertModal(
        getResourceTo('galleryPopup.fileFormatError')
      ).show();
      return;
    }

    const base64Image = data.target.result;

    uploadPhoto(base64Image, extensionImage);
  };

  const handleUploadFile = ({ target }) => {
    const { files } = target;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (data) => processFile(file, data);
    });
  };

  return (
    <label
      type="button"
      className={`upload-button ${isLoading ? 'loading' : ''} ${
        type === 'rounded' ? 'rounded' : ''
      }`}
      data-testid="upload-button"
    >
      <img src={UploadIcon} alt={getResourceTo('gallerypopup.uploadbutton')} />
      <span>
        {isLoading
          ? getResourceTo('gallerypopup.loading')
          : getResourceTo('gallerypopup.uploadbutton')}
      </span>
      <input
        data-testid="photo-album-upload-input"
        type="file"
        accept=".jpg, .jpeg, .png"
        onChange={handleUploadFile}
      />
    </label>
  );
}

UploadButton.defaultProps = {
  type: 'default'
};

UploadButton.propTypes = {
  data: PropTypes.object.isRequired,
  albums: PropTypes.array.isRequired,
  fetchAlbums: PropTypes.func.isRequired,
  type: PropTypes.string
};

export default UploadButton;
